import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import Stat from './Stat';
import styles from './StatsRow.module.scss';

interface StatsRowProps {
    stats: {
        label: GenericLazyString | string;
        value: GenericLazyString | string;
    }[];
    className?: string;
}

export const StatsRow: React.FC<StatsRowProps> = ({ stats, className }) => {
    return (
        <div className={`${styles.statsRow} ${className || ''}`}>
            {stats.map((stat, index) => (
                <React.Fragment key={stat.label.toString()}>
                    <Stat
                        label={stat.label.toString()}
                        value={stat.value.toString()}
                    />
                    {index < stats.length - 1 && (
                        <div className={styles.divider} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
